import './bootstrap';

// Bootbox

import bootbox from 'bootbox';
window.bootbox = bootbox;

// Bootstrap Date Range Picker

import daterangepicker from 'bootstrap-daterangepicker';
window.daterangepicker = daterangepicker;

// Bootstrap Table

import 'bootstrap-table';
import 'bootstrap-table/dist/locale/bootstrap-table-nl-NL.js';
import 'bootstrap-table/dist/locale/bootstrap-table-de-DE.js';
import 'bootstrap-table/dist/locale/bootstrap-table-fr-FR.js';
import 'bootstrap-table/dist/locale/bootstrap-table-it-IT.js';
import 'bootstrap-table/dist/locale/bootstrap-table-es-ES.js';
import 'bootstrap-table/dist/locale/bootstrap-table-zh-CN.js';

// Bootstrap Table - Extensions - Table Mobile
import 'bootstrap-table/dist/extensions/mobile/bootstrap-table-mobile.js';

// Chart.js

import chart from 'chart.js/auto';
window.Chart = chart;

// Chosen
import 'chosen-js';

// Flatpickr

import { Dutch } from 'flatpickr/dist/l10n/nl';
import { German } from 'flatpickr/dist/l10n/de';
import { French } from 'flatpickr/dist/l10n/fr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Italian } from 'flatpickr/dist/l10n/it';

const languageMap = {
    nl: Dutch,
    de: German,
    fr: French,
    es: Spanish,
    it: Italian,
};

window.flatpickr = require('flatpickr');

window.flatpickrLanguageSwitch = (locale = 'en') => {
    return languageMap[locale] || undefined;
};

// jQuery - Date Time Picker
import 'jquery-datetimepicker';

// jQuery Migrate
import 'jquery-migrate';

// jQuery UI - full build (includes autocomplete, sortable, and dependencies)
import 'jquery-ui/dist/jquery-ui.js';

// Moment.js

import moment from 'moment';
window.moment = moment;

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Sprintf-js
window.sprintf = require('sprintf-js').sprintf;
window.vsprintf = require('sprintf-js').vsprintf;

// SweetAlert2

import sweetalert2 from 'sweetalert2';
window.Swal = sweetalert2;

// App

require('./app/i18n.js');
require('./app/actions.js');
require('./app/can.js');
require('./app/chosen.js');
require('./app/colorCellStyle.js');
require('./app/datepicker.js');
require('./app/daterangepicker.js');
require('./app/dialog_google_maps.js');
require('./app/font_awesome.js');
require('./app/nbrogress.js');
// require('./app/online.js');
// require('./app/password.js');
require('./app/ready.js');
require('./app/sidebar.js');
require('./app/tables.js');
require('./app/tabs.js');
require('./app/tile.js');
require('./app/tooltip.js');
require('./app/validation.js');

// Cell Styles

require('./app/cellStyles/ar/documents/status_client.js');
require('./app/cellStyles/ar/documents/status_freelancer.js');
require('./app/cellStyles/ar/transactions/credits.js');

// Formatters

require('./app/formatters/ar/announcement/detail.js');
require('./app/formatters/ar/apis/kvk/requestDetail.js');
require('./app/formatters/ar/apis/kvk/cacheDetail.js');
require('./app/formatters/ar/apis/kvk/status.js');
require('./app/formatters/ar/assignment/resubmit.js');
require('./app/formatters/ar/audit/detail.js');
require('./app/formatters/ar/client/verified.js');
require('./app/formatters/ar/contactForm/detail.js');
require('./app/formatters/ar/contract/detail.js');
require('./app/formatters/ar/contract/document_model_agreement.js');
require('./app/formatters/ar/contract/document_non_disclosure_agreement.js');
require('./app/formatters/ar/curriculum_vitae/download.js');
require('./app/formatters/ar/curriculum_vitae/reference/detail.js');
require('./app/formatters/ar/curriculum_vitae/work_experience/detail.js');
require('./app/formatters/ar/document/download.js');
require('./app/formatters/ar/employee/detail.js');
require('./app/formatters/ar/freelancer/verified.js');
require('./app/formatters/ar/faq/detail.js');
require('./app/formatters/ar/purchase/invoice/detail.js');
require('./app/formatters/ar/purchase/invoice/download.js');
require('./app/formatters/ar/sales/invoice/creditedBy.js');
require('./app/formatters/ar/sales/invoice/creditedFor.js');
require('./app/formatters/ar/sales/invoice/detail.js');
require('./app/formatters/ar/sales/invoice/download.js');
require('./app/formatters/ar/amountExclVat.js');
require('./app/formatters/ar/client.js');
require('./app/formatters/ar/curriculum_vitae.js');
require('./app/formatters/ar/freelancer.js');
require('./app/formatters/ar/page/detail.js');
require('./app/formatters/ar/pricePerCredit.js');
require('./app/formatters/ar/reaction/detail.js');
require('./app/formatters/ar/relation.js');
require('./app/formatters/color.js');
require('./app/formatters/active.js');
require('./app/formatters/amountFooter.js');
require('./app/formatters/audit/detail.js');
require('./app/formatters/avatar.js');
require('./app/formatters/boolean.js');
require('./app/formatters/country/icon.js');
require('./app/formatters/settings/service/detail.js');
require('./app/formatters/delete.js');
require('./app/formatters/duplicate.js');
require('./app/formatters/edit.js');
require('./app/formatters/email.js');
require('./app/formatters/fontAwesome.js');
require('./app/formatters/googleMaps.js');
require('./app/formatters/loginAs.js');
require('./app/formatters/phone.js');
require('./app/formatters/rowStyle.js');
require('./app/formatters/show.js');
require('./app/formatters/sortable.js');
require('./app/formatters/tags.js');
require('./app/formatters/url.js');

// Functions

require('./app/functions/number_format_to_decimal.js');
require('./app/functions/number_format.js');
